/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxCategoryListResponse } from '../../models/tax-category-list-response';

export interface TaxCategoriesGet$Params {
  'Active-Tenant-Identifier': string;
  size?: number;
  page?: string;
  filterByTenant?: boolean;
  aggregatorId?: string;
  search?: string;
  sortOrder?: 'asc' | 'desc';
}

export function taxCategoriesGet(http: HttpClient, rootUrl: string, params: TaxCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategoryListResponse>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('size', params.size, {});
    rb.query('page', params.page, {});
    rb.query('filterByTenant', params.filterByTenant, {});
    rb.query('aggregatorId', params.aggregatorId, {});
    rb.query('search', params.search, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxCategoryListResponse>;
    })
  );
}

taxCategoriesGet.PATH = '/tax-categories';
